import {takeEvery} from 'redux-saga/effects'

import {
  ENFORCE_MFA_TOGGLE,
  GENERATE_EMAIL_OTP,
  GENERATE_MFA_OTP,
  GET_EMAIL_VERIFICATION_STATUS,
  SEND_STUDENT_PARENT_VERIFICATION_EMAILS,
  VERIFY_EMAIL_OTP,
  VERIFY_MFA_OTP,
  VERIFY_STUDENT_PARENT_EMAIL,
} from '../../Actions/UserSecurityDetails/ActionTypes/ApiActionTypes'
import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(GET_EMAIL_VERIFICATION_STATUS, fetchData)
  yield takeEvery(GENERATE_EMAIL_OTP, fetchData)
  yield takeEvery(VERIFY_EMAIL_OTP, fetchData)
  yield takeEvery(GENERATE_MFA_OTP, fetchData)
  yield takeEvery(VERIFY_MFA_OTP, fetchData)
  yield takeEvery(ENFORCE_MFA_TOGGLE, fetchData)
  yield takeEvery(SEND_STUDENT_PARENT_VERIFICATION_EMAILS, fetchData)
  yield takeEvery(VERIFY_STUDENT_PARENT_EMAIL, fetchData)
}

export default dataSaga
